<template>
  <li>
    <h6 class="dropdown-header">
      <slot />
    </h6>
  </li>
</template>
